import { Pipe, PipeTransform } from '@angular/core';

import { unique } from '@fcom/core/utils';

@Pipe({
  name: 'finUnique',
  pure: true,
  standalone: false,
})
export class UniquePipe implements PipeTransform {
  transform<T>(array?: T[]): T[] {
    if (!Array.isArray(array)) {
      return array;
    }
    const filtered = array.filter(unique);
    return filtered.length === array.length ? array : filtered;
  }
}
